import React, { Component, useState, useEffect } from 'react';
import News_app from './News';
import logo from './logo.png';

const The_app = () => {
	return (
		<div style={{ maxHeight: '100vh', overflow: 'hidden' }}>
			<nav class='navbar sticky-top navbar-dark' style={{ zIndex: '1' }}>
				<a class='' href='#'>
					<img class='logo' src={logo} alt='aaa' /> Tech Feeds
				</a>
				<button
					class='navbar-toggler'
					type='button'
					data-toggle='drawer'
					data-target='#dw-s2'
					style={{ border: 'none' }}
				>
					<span class='material-icons'> menu </span>
				</button>
			</nav>
			<div class='bmd-layout-container bmd-drawer-f-l bmd-drawer-overlay bg-dark' style={{ overflow: 'hidden' }}>
				<div
					id='dw-s2'
					class='bmd-layout-drawer bg-faded bg-dark'
					style={{ zIndex: '9999999', marginTop: '-30px', minHeight: '105vh' }}
				>
					<ul class='list-group'>
						<br />
						<a class='list-group-item' href={'https://github.com/arunabharjun'}>
							<i class='fab fa-github' /> Arunabh Arjun
						</a>
					</ul>
				</div>
				<main class='bmd-layout-content' style={{ maxHeight: '95vh', overflowY: 'scroll' }}>
					<div class='container center_itm'>
						<br />
						<News_app />
						<br />
						{/* Main content Here */}
					</div>
				</main>
			</div>
		</div>
	);
};

const App = () => {
	return <The_app />;
};

export default App;
